/* ==========================================================================
   [AYNI] Media Carousel — assets/ayni-media-carousel.js
   Custom Element <ayni-mc>: horizontaler Scroll-Carousel mit
   Prev/Next-Buttons und optionalem Autoplay.
   Keine externen Abhängigkeiten.
   ========================================================================== */

(() => {
  class AyniMC extends HTMLElement {
    connectedCallback() {
      this._track    = this.querySelector('.ayni-mc__track');
      this._prevBtns = this.closest('section, .shopify-section').querySelectorAll('.js-ayni-mc-prev');
      this._nextBtns = this.closest('section, .shopify-section').querySelectorAll('.js-ayni-mc-next');
      this._autoplay = this.dataset.autoplay === 'true';
      this._speed    = parseInt(this.dataset.autoplaySpeed) || 4000;

      if (!this._track) return;

      this._prevBtns.forEach(b => b.addEventListener('click', () => this._scroll(-1)));
      this._nextBtns.forEach(b => b.addEventListener('click', () => { this._stopAuto(); this._scroll(1); }));
      this._track.addEventListener('scroll', () => this._updateNav(), { passive: true });
      this._track.addEventListener('pointerdown', () => this._stopAuto(), { once: true });

      this._updateNav();
      if (this._autoplay) this._startAuto();
    }

    _scroll(dir) {
      const item = this._track.querySelector('.ayni-mc__item');
      if (!item) return;
      const gap  = parseFloat(getComputedStyle(this._track).gap) || 0;
      const step = item.offsetWidth + gap;
      const maxLeft = this._track.scrollWidth - this._track.clientWidth;

      let target = this._track.scrollLeft + dir * step;
      // Wrap-around
      if (target > maxLeft + 1) target = 0;
      if (target < -1)          target = maxLeft;

      this._track.scrollTo({ left: target, behavior: 'smooth' });
    }

    _updateNav() {
      const { scrollLeft, scrollWidth, clientWidth } = this._track;
      const atStart = scrollLeft < 2;
      const atEnd   = scrollLeft + clientWidth >= scrollWidth - 2;
      this._prevBtns.forEach(b => { b.disabled = atStart; });
      this._nextBtns.forEach(b => { b.disabled = atEnd;   });
    }

    _startAuto() {
      this._timer = setInterval(() => this._scroll(1), this._speed);
    }

    _stopAuto() {
      clearInterval(this._timer);
    }
  }

  if (!customElements.get('ayni-mc')) {
    customElements.define('ayni-mc', AyniMC);
  }
})();